import { createSlice } from '@reduxjs/toolkit'
import { fetchSymbols } from '../thunks/watchlist';

export const watchListSlice = createSlice({
    name: 'watchlist',
    initialState: {
        symbols: {},
    },
    reducers: {
        setSymbolsData: (state, action) => {
            state.symbols = action.payload
        },
        addNewSymbol: (state, action) => {
            state.symbols[action.payload.id] = action.payload; 
        },
        updateSymbol: (state, action) => {
            if (state.symbols[action.payload.id]) {
                state.symbols[action.payload.id] = action.payload;
            }
        },
        deleteSymbol: (state, action) => {
            delete state.symbols[action.payload]; 
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchSymbols.fulfilled, (state, action) => {
            state.symbols = action.payload;
        })
    }
})

// Action creators are generated for each case reducer function
export const { setSymbolsData ,addNewSymbol,updateSymbol,deleteSymbol} = watchListSlice.actions

export default watchListSlice.reducer